"use client";

import dynamic from "next/dynamic";

import type { SpeechEngineLayoutProps } from "./SpeechEngineLayout";

const SpeechEngineLayout = dynamic(() => import("./SpeechEngineLayout"));

export default function SpeechEngine(props: SpeechEngineLayoutProps) {
  return <SpeechEngineLayout {...props} />;
}
